import { Component } from '@angular/core';

@Component({
  moduleId: module.id,
  selector: 'app',
  template: `<router-outlet></router-outlet>`,
  styleUrls: ['../assets/sass/style.scss']
})
export class AppComponent {

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts